import { render, staticRenderFns } from "./editRater.vue?vue&type=template&id=299e3c9a&"
import script from "./editRater.vue?vue&type=script&lang=js&"
export * from "./editRater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports